import { render } from "./BackEnd.vue?vue&type=template&id=05649d73&scoped=true"
import script from "./BackEnd.vue?vue&type=script&lang=js"
export * from "./BackEnd.vue?vue&type=script&lang=js"

import "./BackEnd.vue?vue&type=style&index=0&id=05649d73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05649d73"]])

export default __exports__